import { BotPlayerKindOne } from './BotPlayerKindOne'
import { BotPlayerKindPP } from './BotPlayerKindPP'

const botRandom = new BotPlayerKindOne()
const BotPP = new BotPlayerKindPP()

export const botKinds = {
  NONE: botRandom,
  BOT_PP: BotPP
}
